export const GET_USER_LIST_REQUEST = "GET_USER_LIST_REQUEST"
export const GET_USER_LIST_SUCCESS = "GET_USER_LIST_SUCCESS"
export const ADD_USER_LIST_REQUEST = "ADD_USER_LIST_REQUEST"
export const ADD_USER_LIST_SUCCESS = "ADD_USER_LIST_SUCCESS"

export const ACTIVE_INACTIVE_USER_REQUEST = "ACTIVE_INACTIVE_USER_REQUEST"
export const ACTIVE_INACTIVE_USER_SUCCESS = "ACTIVE_INACTIVE_USER_SUCCESS"
